@if ($model() != null && $flowDefinitionOrganizationId() != null) {
    <!-- Nível de Acesso -->
    <div class="form-group" featureHint="flowObjectDetails|AccessLevelId" featureHintHAlign="right">
        <label for="accessLevelId">Nível de Acesso</label>

        <select class="form-control info-font" id="accessLevelId" name="accessLevelId" required
                [ngModel]="$model().id"
                [matTooltip]="$model().name"
                [disabled]="_isReadOnlyMode"
                (change)="accessLevelIdChange($event.target.value)"
        >
            @for (option of accessLevelTypeOptions; track option) {
                <option [value]="option.value">{{option.description}}</option>
            }
        </select>
    </div>

    @if (shouldFilterFundamentos()) {
        <!-- Seletor de filtro de fundamentos -->
        <div featureHint="flowObjectDetails|AccessLevelFilterType" featureHintHAlign="right">
            <mat-radio-group class="filter-type mb-2" id="fundamentoFilterType" name="fundamentoFilterType" color="primary"
                             [ngModel]="$fundamentoFilterType()"
                             [disabled]="_isReadOnlyMode"
                             [required]="true"
                             (ngModelChange)="fundamentoFilterTypeChange($event)"
            >
                <mat-radio-button [value]="AccessLevelFilterType.Citizen">Exibir apenas Fundamentos permitidos para o Cidadão</mat-radio-button>
                <mat-radio-button [value]="AccessLevelFilterType.Patriarch">Exibir Fundamentos do seguinte Patriarca:</mat-radio-button>
            </mat-radio-group>
        </div>

        <!-- Patriarcas -->
        @if ($fundamentoFilterType() == AccessLevelFilterType.Patriarch) {
            <div class="form-group ml-4" featureHint="flowObjectDetails|AccessLevelPatriarch" featureHintHAlign="right">
                <label for="patriarcaId">Selecione um Patriarca para filtrar os Fundamentos Legais mais abaixo</label>

                <input type="text" class="form-control info-font one-button" id="patriarcaDisplay" name="patriarcaDisplay"
                       placeholder="(nenhum selecionado)"
                       [ngModel]="$patriarcaDisplay()"
                       [matTooltip]="$patriarcaNome()"
                       [matAutocomplete]="patriarcaAutocomplete"
                       (ngModelChange)="$patriarcaDisplay.set($event)"
                       (input)="patriarcaDisplayChange()"
                >

                <mat-autocomplete #patriarcaAutocomplete="matAutocomplete"
                                  [displayWith]="displayPatriarcaId"
                                  (optionSelected)="patriarcaIdChange($event)"
                >
                    @for (option of $selectablePatriarcas(); track option) {
                        <mat-option class="uppercase" [value]="option">{{option.sigla}} - {{option.nome}}</mat-option>
                    }
                </mat-autocomplete>

                <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearPatriarca()" (keyDown)="clearPatriarca()"></i>
            </div>
        }

        <!-- Fundamentos Disponíveis -->
        <div class="form-group position-relative" featureHint="flowObjectDetails|AccessLevelAvailable" featureHintHAlign="right"
             [ngClass]="$fundamentoFilterType() == AccessLevelFilterType.Patriarch ? 'ml-5' : 'ml-4'"
        >
            <label for="fundamentoId">Selecione um dos Fundamentos disponíveis e o adicione à lista abaixo</label>

            <input type="text" class="form-control info-font one-button" id="fundamentoDisplay" name="fundamentoDisplay"
                   placeholder="(nenhum selecionado)"
                   [ngModel]="$fundamentoDisplay()"
                   [matTooltip]="$fundamentoDescricao()"
                   [disabled]="$isFundamentoDisplayDisabled()"
                   [matAutocomplete]="fundamentoAutocomplete"
                   (ngModelChange)="$fundamentoDisplay.set($event)"
                   (input)="fundamentoDisplayChange()"
            >

            <mat-autocomplete #fundamentoAutocomplete="matAutocomplete"
                              [displayWith]="displayFundamentoId"
                              (optionSelected)="fundamentoIdChange($event)"
            >
                @for (option of $selectableFundamentos(); track option) {
                    <mat-option class="uppercase" [value]="option">{{option.nivelAcesso}} - {{option.nome}}</mat-option>
                }
            </mat-autocomplete>

            <i class="fas fa-plus-circle action add ml-2" matTooltip="Adicionar Fundamento Legal"
               (click)="addFundamento(fundamentacaoLegalRef)"
               (keyDown)="addFundamento(fundamentacaoLegalRef)"
            ></i>
        </div>

        <!-- Fundamentação Legal selecionada -->
        <div class="form-group position-relative" featureHint="flowObjectDetails|AccessLevelSelected" featureHintHAlign="right"
             [ngClass]="$fundamentoFilterType() == AccessLevelFilterType.Patriarch ? 'ml-6' : 'ml-5'"
        >
            <label for="legalReasoningIds">Fundamentação Legal selecionada</label>

            <select multiple class="form-control info-font styled-scrollbar one-button" size="3" #fundamentacaoLegalRef
                    id="legalReasoningIds"
                    name="legalReasoningIds"
                    [disabled]="_isReadOnlyMode"
                    [matTooltip]="fundamentosNomes"
            >
                @for (option of $selectedFundamentos(); track option.value) {
                    <option class="uppercase" [value]="option.value">{{(Utils.isNotNullOrEmpty(option.value) && Utils.isNotNullOrEmpty(option.description) ? option.description : Enums.Messages.DefaultEmptyValue)}}</option>
                }
            </select>

            <i class="fas fa-minus-circle action remove multiple ml-2" matTooltip="Remover Fundamento Legal"
               (click)="removeFundamento(fundamentacaoLegalRef)"
               (keyDown)="removeFundamento(fundamentacaoLegalRef)"
            ></i>
        </div>
    }
}
